import { shouldNoIndexPath } from "#shared/noIndexPaths";

export default defineNuxtRouteMiddleware((to) => {
  if (!shouldNoIndexPath(to.path)) return;

  useSeoMeta({
    robots: "noindex, nofollow",
  });
});
